import { useTheme } from '@emotion/react'
import { Grid, Paper, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { G300, } from '../../ui-components/CustomButton'
import { useNavigate } from 'react-router-dom';
import AuthWrapper1 from './AuthWrapper1';
import { useConfig } from '../../dynamic-configuration/configContext';
import WhatsAppSuccessLogoImage from '../../ui-components/WhatsAppSuccessLogoImage';
import backrr_icon from "../../assets/backrr_favicon.png"
import backrr_tick from "../../assets/backrr_tick.png"
import Cookies from "js-cookie"

const WhatsAppSuccessScreen = ({ Action }) => {
    const { config } = useConfig()
    const theme = useTheme();
    const navigate = useNavigate();
    const isTableorLargerScreen = useMediaQuery(theme.breakpoints.up('sm'))
    //theme.palette.background.paper
    // "#FFFFFF"
    return (
        // <AuthWrapper1>
            <Grid sx={{ display: "grid", placeContent: 'center', height: "100vh" }}>
                <Paper sx={{
                    backgroundColor: theme.palette.background.paper, boxShadow: 3, padding: '2rem', flex: 1, overflowY: "auto", overflowX: "hidden", maxHeight: "578px", borderRadius: "48px",
                    // scale: {xs: "0.8", sm: "0.9", lg: "1"},
                    scale: "0.9",
                    maxWidth: "450px"
                }}>
                    <Grid container xs={12} display={'grid'} sx={{ placeItems: "center", placeContent: "center", gap: "2rem" }}>
                        {/* Header */}
                        <Grid item display={"grid"} sx={{ placeItems: "center", placeContent: "center", gap: 2 }}>
                            <WhatsAppSuccessLogoImage />
                            <Typography variant='caption' sx={{ fontSize: "1rem", fontWeight: 700, textAlign: 'center' }}>
                                {config?.dynamicText?.thankyouMessageWhatsApp}
                            </Typography>
                        </Grid>
                        {/* Content */}
                        <Grid sx={{ border: '1px solid #ADA2ED', background: "#EBE8FB", padding: "1.5rem", borderRadius: "8px", display: 'flex' }}>
                            <img src={backrr_icon} style={{ height: "4.5rem", maxWidth: "4.5rem" }} alt='backr_icon' />
                            <ol class="MuiBreadcrumbs-ol" style={{ margin: 0, paddingLeft: isTableorLargerScreen ? "1.5rem" : "1rem" }}>
                                <Typography display={'flex'} alignItems={'center'} gap={0.5}>
                                    <h3>{config?.dynamicText?.backrr}</h3>
                                    <img src={backrr_tick} style={{ height: "2.3rem", maxWidth: "2.3rem" }} alt='backrr_tick' />
                                </Typography>
                                <Typography variant='body2' sx={{ fontSize: "1rem", fontWeight: 500, }}>
                                    {config?.dynamicText?.whatsAppEnable}
                                </Typography>

                            </ol>
                        </Grid>
                        {/* Footer */}
                        <Grid display={"grid"} gap={1} xs={12} sx={{ width: "100%" }}>
                            <G300 fullWidth={true} sx={{ background: "#000", padding: 2, textTransform: "none" }} onClick={() => {
                                Action()
                                // navigate("/onboarding"); Cookies.set("step", 11)
                            }}>
                                {config?.dynamicText?.continue}
                            </G300>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        // </AuthWrapper1>
    )
}

export default WhatsAppSuccessScreen